module.exports = __webpack_public_path__ + "static/media/soccer_prof.a02d8f79.jpg";